/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updates_RestartInputs */

const tr_updates_restart = /** @type {(inputs: Updates_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeniden Başlat`)
};

const en_updates_restart = /** @type {(inputs: Updates_RestartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restart Now`)
};

/**
* | output |
* | --- |
* | "Restart Now" |
*
* @param {Updates_RestartInputs} inputs
* @param {{ locale?: "tr" | "en" }} options
* @returns {LocalizedString}
*/
export const updates_restart = /** @type {((inputs?: Updates_RestartInputs, options?: { locale?: "tr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updates_RestartInputs, { locale?: "tr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "tr") return tr_updates_restart(inputs)
	return en_updates_restart(inputs)
});